"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createInteractivity = exports.collectPotentialHotspotIds = void 0;
const vlx_types_1 = require("@sundaysky/vlx-types");
const traverse_1 = __importDefault(require("traverse"));
const consts_1 = require("./consts");
const logic_1 = require("./logic");
function collectPotentialHotspotIds(variables) {
    const hotspotIds = [];
    variables.forEach(variable => {
        (0, traverse_1.default)(variable).forEach((node) => {
            if (node && node.type === consts_1.HOTSPOT) {
                if (node.rules) { // standalone hotspots
                    node.rules.forEach(rule => {
                        rule.value && rule.value.id && hotspotIds.push(rule.value.id.value);
                    });
                }
                if (node.value) { // grouped hotspots
                    hotspotIds.push(node.value.id.value);
                }
            }
        });
    });
    return hotspotIds;
}
exports.collectPotentialHotspotIds = collectPotentialHotspotIds;
function createInteractivity(retLineup, storyLineup, context) {
    let interactivity = {};
    let actionDefs = {};
    let onPage = {};
    storyLineup.forEach((scene) => {
        if (scene && scene.scene && Array.isArray(scene.scene.variables) && retLineup[vlx_types_1.METADATA].valid[scene.name]) {
            const hotspotIds = collectPotentialHotspotIds(scene.scene.variables);
            if (hotspotIds.length) {
                let hotspotOnPage = [];
                scene.scene.variables.forEach(variable => {
                    let resolvedVar = (0, logic_1.resolveLogic)(variable, context);
                    (0, traverse_1.default)(resolvedVar).forEach(function (node) {
                        if (node && node.id && hotspotIds.includes(node.id)) {
                            hotspotOnPage.push({ data: { actionRef: node.id } });
                            actionDefs[node.id] = node;
                        }
                    });
                });
                onPage[scene.name] = hotspotOnPage;
            }
        }
    });
    interactivity.actionDefs = actionDefs;
    interactivity.onPage = onPage;
    return interactivity;
}
exports.createInteractivity = createInteractivity;
//# sourceMappingURL=interactivity.js.map